import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {Observable} from 'rxjs';
import {AuthenticationService} from './services/auth/authentication.service';
import {isPlatformBrowser} from '@angular/common';
import {Utils} from './utils.class';
import {Routenames} from './routenames';
import {LocalStorage} from './utils/storage';

@Injectable()
export class IsAuthenticated  {
    constructor(private router: Router,
                private authenticationService: AuthenticationService,
                @Inject(PLATFORM_ID) private platformId: Object) {
    }
    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        if (!LocalStorage.userToken) {
            this.authenticationService.setRedirect(window.location.pathname + window.location.search);
            LocalStorage.logoutUser();
            setTimeout(() => {
                this.router.navigate([Routenames.Login]);
            });
            return false;
        } else {
            const tokenData = Utils.getJwtData(LocalStorage.userToken);
            if (tokenData && tokenData.needsOtp) {
                if (LocalStorage.user.hasOtp) {
                    this.router.navigate([Routenames.Twofactor]);
                } else {
                    this.router.navigateByUrl(`${Routenames.TwofactorSetup}`);
                }
                return false;
            }

        }
        return true;
    }
}
